import { useIsSignedIn } from "PFApp/hooks";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { FeatureFlag } from "PFCore/types/feature_flag";
import { ApiRoute, UiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { Navigate } from "react-router";

const SamlSignInPage = () => {
  const { data: currentAccount } = useCurrentAccount();
  const { isSignedIn } = useIsSignedIn();
  const initOnAccountDomain = useIsFeatureEnabled(FeatureFlag.SamlAccountDomainCallback);

  useEffect(() => {
    if (!isSignedIn) {
      const authorizeParams = new URLSearchParams({
        account: currentAccount.full_domain,
        client_id: window.PF.config.client_id || "",
        grant_type: "saml",
        redirect_uri: UiRoute("/")
      });
      // eslint-disable-next-line react-hooks/immutability
      window.location = ApiRoute(`/api/oauth/authorize?${authorizeParams.toString()}`, {
        relative: initOnAccountDomain
      });
    }
  }, [isSignedIn, currentAccount.full_domain, initOnAccountDomain]);

  if (isSignedIn) {
    return <Navigate to="/" replace />;
  }

  return null;
};

export default SamlSignInPage;
